import { render, staticRenderFns } from "./PositionAndSize.vue?vue&type=template&id=35e2ce34&scoped=true"
import script from "./PositionAndSize.vue?vue&type=script&lang=js"
export * from "./PositionAndSize.vue?vue&type=script&lang=js"
import style0 from "./PositionAndSize.vue?vue&type=style&index=0&id=35e2ce34&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35e2ce34",
  null
  
)

export default component.exports